module.exports = __webpack_public_path__ + "img/coco.d8b5ab67.png";